import { fetchAllIpoPages } from "./fetchAllIpoPages";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_IPOS } from "../../../config/api";

// Walks every page so the list is never cut at the 20-row server default.
export const getIpos = createAsyncThunk(
  "ipos/getAll",
  async (_, { rejectWithValue }) => {
    try {
      return await fetchAllIpoPages({ path: API_IPOS, key: "ipos" });
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
